const R = 6_371_000;
function haversineM(aLon, aLat, bLon, bLat) {
    const dLat = ((bLat - aLat) * Math.PI) / 180;
    const dLon = ((bLon - aLon) * Math.PI) / 180;
    const s = Math.sin(dLat / 2) ** 2 +
        Math.cos((aLat * Math.PI) / 180) * Math.cos((bLat * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
}
/** Finn avvik i det gjeldende situasjonsbildet. Deterministisk + rekkefølge-
 * stabil (sortert på trackId) — enkel å teste og cache. */
export function detectAnomalies(tracks, opts = {}) {
    const low = opts.lowConfidence ?? 0.4;
    const clusterM = opts.clusterM ?? 400;
    const dets = tracks.filter((t) => t.kind === 'detection');
    const out = [];
    for (const d of dets) {
        if (d.confidence !== undefined && d.confidence < low) {
            out.push({ trackId: d.id, code: 'lav-tillit', severity: 'info', note: `Lav tillit (${Math.round(d.confidence * 100)} %)` });
        }
    }
    // Mulige dubletter: to deteksjoner av samme type, fra ULIK kilde, nær
    // hverandre → kandidat for entitetsoppløsning (samme objekt sett to steder).
    for (let i = 0; i < dets.length; i++) {
        for (let j = i + 1; j < dets.length; j++) {
            const a = dets[i], b = dets[j];
            if (a.source === b.source)
                continue;
            if (haversineM(a.lon, a.lat, b.lon, b.lat) <= clusterM) {
                out.push({ trackId: a.id, code: 'mulig-samme-mål', severity: 'varsel', note: `Mulig samme mål som ${b.label}` });
            }
        }
    }
    return out.sort((x, y) => x.trackId.localeCompare(y.trackId));
}
/** Kart av trackId → viktigste avvik (varsel > info) for rask oppslag i UI. */
export function anomalyByTrack(anomalies) {
    const m = new Map();
    for (const a of anomalies) {
        const cur = m.get(a.trackId);
        if (!cur || (cur.severity === 'info' && a.severity === 'varsel'))
            m.set(a.trackId, a);
    }
    return m;
}
//# sourceMappingURL=triage.js.map